import { ChevronLeft, ChevronRight } from 'lucide-react';
import { CanvasHeaderTools } from '@/workspace/canvas-footer';
import { useOptionalWorkspace } from '@/workspace/context';
import { useChatInterfaceLocale } from '@/lib/chat-i18n';
import { actionCopy } from './action-copy';
import { actionSurfaceCopy } from './action-surface-copy';
import { useActionSummary } from './action-approval-copy';
import { actionUsesCanvas } from './action-layout';
import { usePendingActions } from './pending-approvals';

export function ActionPager({ id }: { id: string }) {
  const summarize = useActionSummary();
  const ws = useOptionalWorkspace();
  const locale = useChatInterfaceLocale();
  const copy = actionCopy(locale);
  const surface = actionSurfaceCopy(locale);
  const entries = usePendingActions().filter((entry) => actionUsesCanvas(entry.action));
  const index = entries.findIndex((entry) => entry.action.id === id);
  if (entries.length < 2 || index < 0) return null;
  const previous = entries[(index + entries.length - 1) % entries.length].action;
  const next = entries[(index + 1) % entries.length].action;
  const number = new Intl.NumberFormat(locale);
  return (
    <CanvasHeaderTools>
      <nav className="pc-action-pager" aria-label={surface.approvalNeeded}>
        <span aria-live="polite">
          {number.format(index + 1)} / {number.format(entries.length)}
        </span>
        <button
          type="button"
          aria-label={`${copy.open}: ${summarize(previous)}`}
          onClick={() => ws?.openCanvas({ kind: 'action', id: previous.id })}
        >
          <ChevronLeft size={16} aria-hidden="true" />
        </button>
        <button
          type="button"
          aria-label={`${copy.open}: ${summarize(next)}`}
          onClick={() => ws?.openCanvas({ kind: 'action', id: next.id })}
        >
          <ChevronRight size={16} aria-hidden="true" />
        </button>
      </nav>
    </CanvasHeaderTools>
  );
}
